import styled from 'styled-components'

export const Container = styled.div``

export const Tickets = styled.div`
  height: calc(100vh - 36px - 54px - 80px);
  overflow: scroll;
  padding: 0;

  > :first-child {
    margin-top: 24px;
  }
`

export const IconWrap = styled.div<{ $bgColor?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: ${(props) => (props.$bgColor ? props.$bgColor : 'var(--primary100)')};
  border-radius: 8px;
`

export const Footer = styled.div`
  padding: 16px 24px;
`
